import { ContentBlock } from "./contentBlock";

export type RichTextBlock = {
    _type: 'richTextBlock';
    content: any;
}

export const isRichTextBlock = (solution: ContentBlock): solution is RichTextBlock => {
    return solution._type === 'richTextBlock';
}